import { Component, NgZone, OnInit } from '@angular/core';
import { User } from '../../models/user';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../../services/user.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from '../../../environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import Swal from 'sweetalert2';
import { MessageService } from 'primeng/api';
import { JsonpClientBackend } from '@angular/common/http';



@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: [
    './login.component.css',
    './css/style.css',
    './font-awesome/css/font-awesome.min.css',
    './perfect-scrollbar/dist/css/perfect-scrollbar.min.css'
  ],
  providers: [UserService]
})

export class LoginComponent implements OnInit {
  public user: User;
  public token;
  public mensaje = {
    status: '',
    message: ''
  };
  public cargando;
  public identity;
  actual = environment.actual;
  logo = environment.entidad[this.actual].urlLogo;
  heightLogo = environment.entidad[this.actual].heightLogo;
  image = `url(${environment.entidad[this.actual].backgroundLogin})`;
  ubicacioLogin = environment.entidad[this.actual].claseUbicacionCajaLogin;
  restablecePass = environment.entidad[this.actual].enlaceRestableceContrasena;
  clausula = environment.entidad[this.actual].clausula;
  crearCuenta = environment.entidad[this.actual].enlaceCrearCuenta;
  messageRestablecePass = environment.entidad[this.actual].mensageRestableceContrasena;
  urlBannerLogin = environment.entidad[this.actual].urlBannerLogin;
  urlTree: any;
  sure: any;



  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _userService: UserService,
    private spinner: NgxSpinnerService,
    private sanitizer: DomSanitizer,
    private ngZone: NgZone,
    private messageService: MessageService
  ) {
    this.user = new User(1, '', '', '', '', '', '', 0, 0);
    // location.reload();
  }

  ngOnInit() {
    console.log(this._route.snapshot.paramMap.get('sure'))
    if (this._route.snapshot.paramMap.get('sure') == '2') {
      this._router.navigate(['/afiliacion'])
    }

    this.salir();
    this.validarSession();
    this.spinner.hide();


    if (this.urlBannerLogin != '') {
      Swal.fire({
        imageUrl: this.urlBannerLogin,
        imageAlt: 'Custom image',
      })
    }
  }

  async validarSession() {
    this.identity = this._userService.GetsessionStorage('identity');
    if (this.identity != '') {
      this._router.navigate(['/home']);
    }
    
    if (this.actual == 'femhel' && environment.production) {
      window.location.href = 'https://www.femhel.com.co';
    }
  }

  onSubmit(form) {
    this.spinner.show();
    let metodo = ''
    if (this.actual == 'clientes') {
      metodo = 'loginCliente'
    } else {
      metodo = 'login'
    }

    this._userService.httpPost(metodo, this.user).subscribe(
      response => {
        const rspta = response;
        if (rspta.status == 'success') {
          this.token = rspta.token;
          this.identity = rspta.user;
          //localStorage.setItem('token', this.token);
          this._userService.SetsessionStorage('token', this.token)
          this._userService.SetsessionStorage('identity', JSON.stringify(this.identity))
          //localStorage.setItem('identity', JSON.stringify(this.identity));

          let data = {
            admin: rspta.admin
          }

          this._userService.httpPost('parametrosGenerales', data).subscribe(
            response => {
              this._userService.SetsessionStorage('parametrosGenerales', JSON.stringify(response))
              //localStorage.setItem('parametrosGenerales', JSON.stringify(response));
              this._userService.httpPost('parametrosIconos', data).subscribe(response => {
                this._userService.SetsessionStorage('iconos', JSON.stringify(response))
                //localStorage.setItem('iconos', JSON.stringify(response));
                this._router.navigate(['/home']);
                this.spinner.hide();
              },
                error => {
                  this.spinner.hide();
                  console.log(error as any);
                  this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ha ocurrido un error, por favor intente más tarde' });
                }
              );
            },
            error => {
              this.spinner.hide();
              console.log(error as any);
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ha ocurrido un error, por favor intente más tarde' });
            }
          );
        } else if (rspta.status == 'successs') {
          this.spinner.hide();
          this.messageService.add({ severity: 'success', summary: '', detail: rspta.message });
          //this.cargando = rspta.message;
        } else {
          this.spinner.hide();
          this.messageService.add({ severity: 'error', summary: 'Error', detail: rspta.message });
          //this.cargando = rspta.message;
        }
      },
      error => {
        console.log('Peticion ajax login')
        console.log(error);
        this.ngZone.onError.asObservable()
        console.log(this.ngZone.onError.observers)

        this._userService.httpAjax('POST', metodo, this.user).then(resp => {
          console.log(JSON.stringify(resp))
          if (resp != 'error') {
            if (resp.status == 'success') {
              this.token = resp.token;
              this.identity = resp.user;
              //localStorage.setItem('token', this.token);
              this._userService.SetsessionStorage('token', this.token)
              localStorage.setItem('identity', JSON.stringify(this.identity));
              this._userService.httpAjax('GET', 'parametrosGenerales', '').then(resp2 => {
                if (resp2 != 'error') {
                  localStorage.setItem('parametrosGenerales', JSON.stringify(resp2));
                  this._userService.httpAjax('GET', 'parametrosIconos', '').then(resp3 => {
                    if (resp3 != 'error') {
                      localStorage.setItem('iconos', JSON.stringify(resp3));
                      this._userService.httpAjax('GET', 'parametrosConfig', '').then(resp4 => {
                        if (resp4 != 'error') {
                          this.spinner.hide();
                          localStorage.setItem('config', JSON.stringify(resp4.details))
                          this._router.navigateByUrl('home');
                        } else {
                          this.spinner.hide();
                          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ha ocurrido un error, por favor intente más tarde' });
                        }
                      })
                    } else {
                      this.spinner.hide();
                      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ha ocurrido un error, por favor intente más tarde' });
                    }
                  })
                } else {
                  this.spinner.hide();
                  this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ha ocurrido un error, por favor intente más tarde' });
                }
              })
            } else {
              this.spinner.hide();
              this.messageService.add({ severity: 'error', summary: 'Error', detail: resp.message });
              //this.cargando = rspta.message;
            }
          } else {
            this.spinner.hide();
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ha ocurrido un error, por favor intente más tarde' });
            //this.cargando = 'Ha ocurrido un error, por favor intente más tarde'
          }
        })
      }
    );

  }

  salir() {
    this._route.params.subscribe(params => {
      const salir = +params.sure;
      if (salir == 1) {
        localStorage.clear();
        sessionStorage.clear()
        this.identity = null;
        this.token = null;

        if (this.actual == 'fondek') {
          window.location.href = 'https://www.kdefon.com/page'
        }
      }
    });
  }

}
